<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>招标书详细信息</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right" @click="goBack()">
                <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>


        <div class="bidding-container" style="width: 1100px; margin: 0 auto;padding: 10px;background-color: #f1f1f1">
            <h1 class="main-subtitle">
                <span style="text-align:left">{{callBidDocInfo.title}}</span>
            </h1>
            <div class="bidding-details">

                <div class="form-single">
                    <div class="title">报名截至时间：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.enrollCloseTime}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">资格预审时间：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.openTime}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">投标截止时间：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.closeTime}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">公布结果时间：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.resultPublishTime}}</label>
                    </div>
                </div>

                <div class="content-caption dashed font18" style="background-color: #fff">
                    <span><span class="color-laber"></span>基本信息</span>
                </div>

                <div class="form-single">
                    <div class="title">联系人：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.contactName}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">联系电话：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.contactTel}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">电子邮箱：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.contactEmail}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">发布时间：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.publishTime}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">申请描述：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.applyDesc}}</label>
                    </div>
                </div>

                <div class="content-caption dashed font18" style="background-color: #fff">
                    <span><span class="color-laber"></span>招标方要求</span>
                </div>
                <div class="form-single">
                    <div class="title">注册资金：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.reqRegCapital == null ? 0 : callBidDocInfo.reqRegCapital}} 万元</label>
                    </div>
                </div>

                <div class="form-single">
                    <div class="title">报名费用：</div>
                    <div class="content">
                        <label v-if="callBidDocInfo.enrollFree" class="mr20">免费</label>
                        <label v-else class="mr20">{{callBidDocInfo.enrollFee}}&nbsp;&nbsp;元</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">成立时间：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.foundDate == null ? '当前日期' : callBidDocInfo.foundDate}}&nbsp;&nbsp;之前</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">保证金：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.reqDeposit}}&nbsp;&nbsp;元</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">招标预算：</div>
                    <div class="content">
                        <label v-if="callBidDocInfo.budgetFlag == 0 " class="mr20">无预算</label>
                        <label v-if="callBidDocInfo.budgetFlag == 2 " class="mr20">固定总额{{callBidDocInfo.budgetAmount}}&nbsp;&nbsp;元</label>
                    </div>
                </div>

                <div class="form-single">
                    <div class="title">招标方式：</div>
                    <div class="content">
                        <label v-if="callBidDocInfo.directed == true " class="mr20">定向招标</label>
                        <label v-if="callBidDocInfo.directed == false " class="mr20">公开招标</label>
                    </div>
                </div>

                <div>
                    <div class="content-caption dashed bg-white">
                        <span>资质类型</span>
                    </div>
                    <table class="custom-tbl">
                        <thead class="head align-left">
                        <tr class="row">
                            <th>招标资质组号</th>
                            <th>招标资质名称</th>
                            <th>招标资质类型</th>
                            <th>是否必须</th>
                        </tr>
                        </thead>
                        <tbody class="body align-left">
                        <tr class="row" v-for="bidQuali in callBidReqQualiList">
                            <td>{{bidQuali.groupNo}}</td>
                            <td class="align-left">{{bidQuali.qualiTypeName}}</td>
                            <td>{{qualiKindList[bidQuali.qualiKind].text}}</td>
                            <td>
                                <div class="table-addr">
                                    <el-radio-group disabled v-model="bidQuali.mandatory">
                                        <el-radio :label=false>否</el-radio>
                                        <el-radio :label=true>是</el-radio>
                                    </el-radio-group>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <div class="content-caption dashed bg-white">
                        <span>招标要求的人员资质</span>
                    </div>
                    <table class="custom-tbl">
                        <thead class="head align-left">
                        <tr class="row">
                            <th>资质类型</th>
                            <th>类型名称</th>
                            <th>类型等级</th>
                            <th>要求数量</th>
                            <th>是否必须</th>
                        </tr>
                        </thead>
                        <tbody class="body align-left">
                        <tr class="row" v-for="staffQuali in callBidDocInfo.staffQualiList">
                            <td class="align-left">{{staffQuali.name}}</td>
                            <td class="align-left">{{staffQuali.qualiName}}</td>
                            <td>
                                <div class="table-addr">
                                    <span v-if="staffQuali.qualiLevel == 1">一级</span>
                                    <span v-if="staffQuali.qualiLevel == 2">二级</span>
                                    <span v-if="staffQuali.qualiLevel == 3">三级</span>
                                    <span v-if="staffQuali.qualiLevel == 4">四级</span>
                                    <span v-if="staffQuali.qualiLevel == 5">五级</span>
                                </div>
                            </td>
                            <td>{{staffQuali.quantity}}</td>
                            <td>
                                <div class="table-addr">
                                    <span v-if="staffQuali.mandatory">是</span>
                                    <span v-else>否</span>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="content-caption dashed bg-white">
                    <span>附件信息</span>
                </div>
                <div class="form-single">
                    <div class="content" style="padding-left: 38px;">
                        <div class="file-area clearfix">
                            <swb-file-item v-for="(file, index) in callBidDocInfo.callBidFileList" :trackKey="index" :fileName="file.name" :fileUuid="file.fileUuid" :fileBrowseUrl="file.fileBrowseUrl" :fileDownloadUrl="file.fileDownloadUrl" :fileMd5="file.fileMd5"></swb-file-item>
                        </div>
                    </div>
                </div>
                <div class="content-caption dashed bg-white">
                    <span>内容摘要</span>
                </div>
                <div class="content" style="padding-left: 38px;">
                    <label>{{callBidDocInfo.digest}}</label>
                </div>

                <div v-if="false"> <!-- 是否定向招标 callBidDocInfo.directed -->
                    <div class="content-caption dashed font18" style="background-color: #fff">
                        <span><span class="color-laber"></span>招标商品</span>
                    </div>

                    <table class="custom-tbl">
                        <thead class="head">
                        <tr class="row">
                            <th>商品名称</th>
                            <th>数量</th>
                            <th>单位</th>
                            <th>说明</th>
                        </tr>
                        </thead>
                        <tbody class="body">
                        <tr class="row" v-for="callBidGoods in callBidDocInfo.callBidGoodsList">
                            <td>{{callBidGoods.name}}</td>
                            <td>{{callBidGoods.quantity}}</td>
                            <td>{{callBidGoods.unit}}</td>
                            <td>{{callBidGoods.desc}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="content-caption dashed bg-white" v-if="callBidDocInfo.callBidGoodsList !=null && callBidDocInfo.callBidGoodsList.length>0">
                    <span>招标商品</span>
                </div>

                <div v-if="callBidDocInfo.callBidGoodsList !=null && callBidDocInfo.callBidGoodsList.length>0">
                    <table class="custom-tbl">
                        <thead class="head">
                        <tr class="row">
                            <th>商品名称</th>
                            <th>数量</th>
                            <th>单位</th>
                            <th>说明</th>
                            <th>操作</th>
                        </tr>
                        </thead>
                        <tbody class="body">
                        <tr class="row" v-for="callBidGoods in callBidDocInfo.callBidGoodsList">
                            <td>{{callBidGoods.name}}</td>
                            <td>{{callBidGoods.quantity}}</td>
                            <td>{{callBidGoods.unit}}</td>
                            <td>{{callBidGoods.desc}}</td>
                            <td><a class="swb-btn-link" @click="toPriceComparison(callBidGoods.name)">比价</a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="content-caption dashed bg-white" v-if="callBidDocInfo.callBidServcList !=null && callBidDocInfo.callBidServcList.length>0">
                    <span>招标服务</span>
                </div>

                <div v-if="callBidDocInfo.callBidServcList !=null && callBidDocInfo.callBidServcList.length>0">
                    <table class="custom-tbl">
                        <thead class="head">
                        <tr class="row">
                            <th>名称</th>
                            <th>描述</th>
                            <th>操作</th>
                        </tr>
                        </thead>
                        <tbody class="body">
                        <tr class="row" v-for="callBidServc in callBidDocInfo.callBidServcList">
                            <td>{{callBidServc.name}}</td>
                            <td>{{callBidServc.desc}}</td>
                            <td><a class="swb-btn-link" @click="toServcComparison(callBidServc.name)">比价</a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="content-caption dashed bg-white" v-if="callBidDocInfo.directed">
                    <span>定向商户</span>
                </div>
                <div v-if="callBidDocInfo.directed">
                    <div class="row" style="line-height: 24px">
                        <span class="inline-block ellipsis-1 mr20" style="width: 200px" v-for="callBidMercht in callBidDocInfo.callBidMerchantList"><span :title="callBidMercht.merchantName">{{callBidMercht.merchantName}}</span></span>
                    </div>
                </div>

                <div class="content-caption dashed bg-white">
                    <span>商务条款</span>
                </div>
                <swb-create-trade-rule v-if="comparedTradeRuleList.length > 0" :comparedTradeRuleList="comparedTradeRuleList" :type="type" :operate="operate" :forBid=true :forGoods="forGoods" :forServc="forServc" ref="swb_create_trade_rule"></swb-create-trade-rule>

            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import callBidApi from '../../api/callBid'

    import SwbCreateTradeRule from '../tradeRule/CreateTradeRule';
    Vue.regist(SwbCreateTradeRule);
    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);

    import SwbPriceComparison from '../priceInpry/PriceComparison';
    Routes.add(SwbPriceComparison);

    import SwbServcComparison from '../priceInpry/ServcComparison';
    Routes.add(SwbServcComparison);

    import SwbCallBidDocList from './CallBidDocList';
    Routes.add(SwbCallBidDocList);

    function sortCallBidReqQuali(itemList) {
        itemList.sort(function (item1, item2) {
            var retValue = item1['groupNo'] - item2['groupNo'];
            if(retValue == 0) {
                retValue = item1['seqNo'] - item2['seqNo']
            }
            return retValue;
        });
        return itemList;
    }

    export default{
        name: 'swb-call-bid-doc-info',
        path: '/call/bid/doc/detail',
        pathOld: '/call/bid/doc/info/to',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '招标书详情',
        data: function () {
            return {
                callBidDocInfo: {},
                callBidReqQualiList: [],
                type: 'callBid',
                comparedTradeRuleList: [],
                qualiKindList: [],
                forGoods: null,
                forServc: null,
                operate: 'chakan'
            }
        },
        created: function () {
            let self = this;
            self.qualiKindList = getEnumList("qualiKind");
            self.getCallBidDocInfo();
        },
        methods: {
            toPriceComparison: function (name) {
                this.$router.push({
                    path: SwbPriceComparison.path,
                    query: {
                        name: name
                    }
                });
            },
            toServcComparison: function (name) {
                this.$router.push({
                    path: SwbServcComparison.path,
                    query: {
                        name: name
                    }
                });
            },
            downloadFile: function (fileDownLoadUrl) {
                Utils.downloadFile(getAppUrl(fileDownLoadUrl));
            },
            viewImage: function (fileBrowseUrl) {
                Utils.setPageUrl(fileBrowseUrl, '_blank');
            },
            // 获取（零售商）招标书信息
            getCallBidDocInfo: function () {
                let self = this;
                let callDocId = this.$route.query.callBidDocId;
                let postData = {};
                postData.id = callDocId;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidDocInfo(postData, function (result) {
                    if(result.type == 'info') {
                        let callBidDocInfo = result.data;
                        if(typeof callBidDocInfo.reqRegCapital == 'number') {
                            callBidDocInfo.reqRegCapital = (callBidDocInfo.reqRegCapital / 10000).round(4);
                        }

                        if(callBidDocInfo.goodsFlag) {
                            self.forGoods = true;
                        }
                        if(callBidDocInfo.servcFlag) {
                            self.forServc = true;
                        }
                        // 商户类型
                        let merchantTypeList = getEnumMap('merchantType', 'value2text');
                        callBidDocInfo.reqMerchantType = merchantTypeList[callBidDocInfo.reqMerchantType];

                        //转注册资金(为万元)
                        self.callBidDocInfo = callBidDocInfo;
                        let callBidReqQualiList = callBidDocInfo.callBidReqQualiList;
                        if(callBidReqQualiList.length > 0) {
                            callBidReqQualiList = sortCallBidReqQuali(callBidReqQualiList);
                        }
                        self.callBidReqQualiList = callBidReqQualiList;

                        self.getTradeRuleInfo();
                        lastMsgBoxDlg.close();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            getTradeRuleInfo: function () {
                let self = this;
                let callDocId = self.$route.query.callBidDocId;
                let postData = {};
                postData.docId = callDocId;
                callBidApi.getCallBidTermList(postData, function (result) {
                    if(result.type == 'info') {
                        let callBidTermList = result.data;
                        if(callBidTermList != null && callBidTermList.length > 0) {
                            self.comparedTradeRuleList = callBidTermList;
                        }
                    }
                });
            },
            downloadDemoFile: function (fileDownloadUrl) {
                Utils.downloadFile(getAppUrl(fileDownloadUrl));
            },

            goBack: function () {
                let self = this;
                let checkState = this.$route.query.checkState;
                this.$router.push({
                    path: SwbCallBidDocList.path,
                    query: {
                        checkState: checkState,
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidDocInfo.vue